<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_expenses'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <!-- <template #cell(expensesdetails)="data">
                  <b-button
                    @click="edit(data.item.expense_id)"
                    type="button"
                    class="btn-sm btn"
                    variant="info"
                    v-b-modal.edit
                  >
                    <i class="mdi mdi-eye"></i> view</b-button
                  >
                </template> -->
                <template #cell(expensesdetails)="data">
                  <span v-if="data.item.amount !==0">
                    <b-button
                      @click="edit(data.item.expense_id)"
                      type="button"
                      class="btn-sm btn"
                      variant="info"
                      v-b-modal.view-visit
                    >
                      <i class="mdi mdi-eye"></i> View
                    </b-button> <span v-if="userData.permissions['edit_expense'] == 1">|  <b-button
                      @click="deleteTrans(data.item.id,data.item.expense_id)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.deleteTransItem
                    >
                      <i class="mdi mdi-delete"></i> 
                    </b-button></span>
                  </span>
               <span v-else>
                <b-button
                      @click="deleteTrans(data.item.id,data.item.expense_id)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.deleteTransItem
                    >
                      <i class="mdi mdi-bin"></i> Delete
                    </b-button>

               </span>
                </template>
                <template #cell(balance)="data">
                  <span v-if="data.item.amount > data.item.paid">
                    {{ data.item.balance }} <br />
                    <b-button
                      @click="
                        pay(
                          data.item.id,
                          data.item.expense_id,
                          data.item.balance
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-cash"></i> pay</b-button
                    >
                  </span>
                  <span v-else class="text-primary">
                    <i class="fas fa-check"></i> Paid
                  </span>
                </template>
              </b-table>
              <span class="total-label">Total Amount:</span>
              <span class="total-value">{{ commas(totalAmount) }}</span>
              <span class="total-label">Total Paid:</span>
              <span class="total-value">{{ commas(totalPaid) }}</span>
              <span class="total-label">Total Balance:</span>
              <span class="total-value">{{ commas(totalBalance) }}</span>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to View Patients Visits</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- <b-modal
      id="view-visit"
      centered
      title="View Expense Details"
      title-class="font-14"
      size="lg"
      hide-footer
    >
      <table
        class="table table-sm mt-2"
        style="color: black;"
        density="compact"
      >
        <thead>
          <tr>
            <th>Category</th>
            <th>Expense</th>
            <th>Amount</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in expensesdetails" :key="item.id">
            <td>{{ item.category.name }}</td>
            <td>{{ item.expense.name }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.description }}</td>
           </tr>
        </tbody>
      </table>

      <div class="form-group d-flex justify-content-end">
        <b-button
          type="button"
          class="btn w-30"
          variant="danger"
          @click="$bvModal.hide('view-visit')"
          >Close</b-button
        >
      </div>
    </b-modal> -->
    <b-modal
  id="view-visit"
  centered
  title="View Expense Details"
  title-class="font-14"
  size="lg"
  hide-footer
>
  <table
    class="table table-sm mt-2"
    style="color: black;"
    density="compact"
  >
    <thead>
      <tr>
        <th>Category</th>
        <th>Expense</th>
        <th>Amount</th>
        <th>Description</th>
      <span v-if="userData.permissions['edit_expense'] == 1">  <th>Actions</th> </span>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in expensesdetails" :key="item.id">
        <td>{{ item.category.name }}</td>
        <td>{{ item.expense.name }}</td>
        <td>{{ item.amount }}</td>
        <td>{{ item.description }}</td>
        <span v-if="userData.permissions['edit_expense'] == 1">
        <td>
          <b-button
            @click="editExpense(item)"
            type="button"
            class="btn-sm btn"
            variant="warning"
          >
            <i class="mdi mdi-pencil"></i> 
          </b-button>
          <b-button
            @click="deleteExpense(item.id)"
            type="button"
            class="btn-sm btn"
            variant="danger"
          >
            <i class="mdi mdi-delete"></i>
          </b-button>
        </td></span>
      </tr>
    </tbody>
  </table>

  <div class="form-group d-flex justify-content-end">
    <b-button
      type="button"
      class="btn w-30"
      variant="danger"
      @click="$bvModal.hide('view-visit')"
      >Close</b-button
    >
  </div>
</b-modal>


    <b-modal
      id="view-pay"
      centered
      title="Expense Payment"
      title-class="font-14"
      hide-footer
    >
      <form @submit.prevent="addPayment">
        <input v-model="expense_id" type="hidden" />
        <div class="form-group mb-2">
          <label>Amount Paid</label>
          <input v-model="amount_paid" type="number" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Payment Method</label>
          <multiselect
            v-model="payment_method"
            :options="paymentoptions"
            label="name"
          ></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Pay Date</label>
          <input v-model="paydate" type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('view-pay')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"
            ><i class="fas fa-check-circle"></i> Submit</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
  id="edit-expense-modal"
  centered
  title="Edit Expense"
  title-class="font-14"
  size="lg"
  hide-footer
>
  <form @submit.prevent="updateExpense">
    <div class="form-group">
      <div class="form-group">
      <label>Category</label>
      <multiselect v-model="category" @input="FilterCategory" label="name" :options="expensecategories"></multiselect>

    </div>
    <div class="form-group">
      <label>Expense</label>
      <multiselect v-model="expenseitem" label="name" :options="expenseitems"></multiselect>

    </div>
      <label>Amount</label>
      <input v-model="amount_paid" type="number" class="form-control" required />
    </div>
    <div class="form-group">
      <label>Description</label>
      <textarea v-model="description" class="form-control" ></textarea>
    </div>
   <br>
    <div class="form-group d-flex justify-content-center">
      <b-button
        type="button"
        class="btn w-30"
        variant="danger"
        @click="$bvModal.hide('edit-expense-modal')"
        >Close</b-button
      >
      <b-button type="submit" class="btn ms-1 w-30" variant="primary" :class="{ disabled: loader4}"
        > 
        <span v-if="loader4"><b-spinner small/></span>
        <span v-else><i class="fas fa-check-circle"></i> Save</span></b-button
      >
    </div>
  </form>
</b-modal>

<b-modal
      id="delete-expense"
      centered
      title="Delete Expense  "
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="removeExpense">
         <input v-model="id" type="hidden"/>
        Are you sure you want to delete this Expense: <b>{{ }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30 fw-bold"
            variant="secondary"
            @click="$bvModal.hide('delete-expense')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="danger" :class="{ disabled: loader2 }">
            <span v-if="loader2"><b-spinner small/></span>
            <span v-else><i class="fas fa-check-circle"></i> YES</span>
          </b-button>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="deleteTransItem"
      centered
      title="Delete Expense  "
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="removeExpenseItem">
        <input v-model="expense_id" type="hidden" />
        Are you sure you want to delete these Expense Items: <b>{{ expense_id }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30 fw-bold"
            variant="secondary"
            @click="$bvModal.hide('deleteTransItem')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="danger" :class="{ disabled: loader3}">
            <span v-if="loader3"><b-spinner small/></span>
            <span v-else><i class="fas fa-check-circle"></i> YES</span>
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  paymentoptionComputed,
  paymentoptionMethods,
  expenseMethods,
  expenseComputed,
  expenseCategoryMethods,
  expenseCategoryComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "View Expenses",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Expenses",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "View Expenses", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "expense_id", label: "Expense ID", visible: true },
        { key: "amount", label: "Total Amount", visible: true },
        { key: "paid", label: "Amount Paid", visible: true },
        { key: "balance", label: "Balance", visible: true },
        { key: "expensesdetails", label: "Action", visible: true },
        { key: "expense_date", label: "Expense Date", visible: true },
      ],
      expensesdetails: [],
      id: "",
      telephone: "",
      name: "",
      gender: "",
      expense_id: "",
      visit_id: "",
      payment_method: "",
      amount_paid: "",
      expenseitem: "",
      category: "",
      description: "",
      amount: "",
      expense:'',
      editingExpense: null,
      loader:false,
      loader2:false,
      loader3:false,
      loader4:false,
      expenseitems: [],
      paydate: new Date().toLocaleDateString("fr-CA"),
    };
  },
  computed: {
    ...expenseComputed,
    ...paymentoptionComputed,
    ...expenseCategoryComputed,
    List() {
      return this.expenses.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.expenses.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.expenses.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    totalAmount() {
      return this.Items.reduce(
        (total, item) => total + parseFloat(item.amount || 0),
        0
      );
    },
    totalPaid() {
      return this.Items.reduce(
        (total, item) => total + parseFloat(item.paid || 0),
        0
      );
    },
    totalBalance() {
      return this.Items.reduce(
        (total, item) => total + parseFloat(item.balance || 0),
        0
      );
    },
  },
  mounted() {
    this.fetchExpenses();
    this.fetchPaymentoptions();
    this.fetchExpensecategories();
    this.TotalRows = this.expenses.length;
    this.isBusy = false;
    this.payment_method = this.paymentoptions.find(
      (option) => option.set_default == 1
    );
  },
  methods: {
    ...expenseMethods,
    ...paymentoptionMethods,
    ...expenseCategoryMethods,
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },


 
    async FilterCategory(){
      let url = `/findexpenseitems/${this.category.id}`;
      await axios.get(url).then((response) => {
        this.expenseitems = response.data.items;
      });
    },

    async edit(expense_id) {
      this.expense_id = expense_id;
      let formData = new FormData();
      formData.append("expense_id", this.expense_id);
      let url = "/expensedetails";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.expensesdetails = response.data.expenses;
          this.$bvModal.show("view-visit");
        }
      });
    },
    pay(id, expense_id, balance) {
      this.id = id;
      this.expense_id = expense_id;
      this.amount_paid = balance;
      this.$bvModal.show("view-pay");
    },
    async addPayment() {
      let formData = new FormData();
      formData.append("expense_id", this.expense_id);
      formData.append("paymentoption", this.payment_method.id);
      formData.append("amount_paid", this.amount_paid);
      formData.append("pay_date", this.paydate);
      let url = "/addexpensepayment";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchExpenses();
          this.$bvModal.hide("view-pay");
          this.expense_id = "";
          this.payment_method = "";
          this.amount_paid = "";
          this.paydate = "";
          this.$toast.success("Expense Payment Added");
        }
      });
    },
    async editExpense(item) {
    this.expense_id = item.id;
    this.amount_paid = item.amount;
    this.description = item.description;
    this.category = item.category;
    this.expense = item.expense;
    this.$bvModal.show("edit-expense-modal");
  },
  async deleteExpense(expense){
  this.expense = expense;
 
    this.$bvModal.show("delete-expense");
 },
  async deleteTrans(id,expense_id){
    this.expense_id = expense_id;
    this.id = id;
     this.$bvModal.show("delete-expenseitem");
  },
  async removeExpense() {
    this.loader2 = true;
      let formData = new FormData();
      formData.append("expense_id", this.expense);
      let url = "/delete-expensedetail"; 
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$bvModal.hide("delete-expense");
          this.$bvModal.hide("view-visit");
          this.$toast.success("Expense deleted successfully");
          this.fetchExpenses();
          this.loader2 = false;

        }
      });
    
  },
  async removeExpenseItem() {
      this.loader3 = true;
      let formData = new FormData();
      formData.append("expense_id", this.expense_id);
      let url = "/delete-expensedetailitems"; 
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$bvModal.hide("deleteTransItem");
          this.$toast.success("Expense deleted successfully");
          this.fetchExpenses();
          this.loader3 = false;
        }
      });
    
  },
  async updateExpense() {
    this.loader4 = true;
    let formData = new FormData();
   formData.append("expense_id", this.expense_id);
    formData.append("amount_paid", this.amount_paid);
    formData.append("description", this.description);
    formData.append("category", this.category.id); 
    formData.append("expense",this.expenseitem.id);
    let url = "/update-expensedetail"; 
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        
        this.$bvModal.hide("edit-expense-modal");
        this.$bvModal.hide("view-visit");
        this.$toast.success("Expense updated successfully");
        this.fetchExpenses();
        this.loader4 = false;
      }
    });
  },
},
};
</script>
<style scoped>
.total-label {
  margin-right: 10px;
}
.total-value {
  font-weight: bold;
  margin-right: 20px;
}
</style>
